// 基点(bps,0~10000)与百分数显示互转。
//
// 2026-06-06 bps 化:后端/DB/API 一律 int bps(6000 = 60%);% 只存在于 UI 显示/输入层。
// 设计源 docs/superpowers/specs/2026-06-06-agent-rate-bps-design.md。

/** bps → 显示用百分数字符串(6000 → "60%";6050 → "60.5%";null/undefined → "—") */
export function formatBps(bps: number | null | undefined): string {
  if (bps == null || !Number.isFinite(bps)) return '—'
  const pct = bps / 100
  return `${Number.isInteger(pct) ? pct : parseFloat(pct.toFixed(2))}%`
}

/** bps → 百分数数值(6000 → 60;表单初值用) */
export function bpsToPercent(bps: number): number {
  return bps / 100
}

/** 表单 % 输入(0~100,最多两位小数)→ bps int;非法/越界 → null */
export function percentToBps(input: string | number): number | null {
  const n = typeof input === 'number' ? input : Number(input)
  if (!Number.isFinite(n) || n < 0 || n > 100) return null
  return Math.round(n * 100)
}
